import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/toggle/toggle.sss';

export default class Toggle extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	onClick() {
		if (this.props.onClick) {
			this.props.onClick();
		}
	}

	render(props) {
		return (
			<button class={joinClasses(s.switch, props.active && s.on, props.class)} onClick={this.onClick} ariaLabel={props?.ariaLabel}>
				<div class={joinClasses(s.toggle)} />
			</button>
		);
	}

}
